import { CollectionDetailEntity } from "domain/entity/Collection/CollectionDetailEntity";
import { CollectionHeaderEntity } from "domain/entity/Collection/CollectionHeaderEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { AdditionChargeVesselEntity } from "domain/entity/CounterCustomerCharge/AdditionChargeVesselEntity";
import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { CounterCustomerChargeSearchCriteria } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeSearchCriteria";
import { ImportReHandlingCriteria } from "domain/entity/CounterCustomerCharge/ImportReHandlingCriteria";
import { PaymentModeAdditionalInfoCriteria } from "domain/entity/CounterCustomerCharge/PaymentModeAdditionalInfoCriteria";
import { axiosDeleteData, axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import chargeAxiosInstance from "../axios/chargeAxiosInstance";
import collectionAxiosInstance from "../axios/collectionAxiosInstance";
import documentAxiosInstance from "../axios/documentAxiosInstance";
import { CounterCustomerChargeRepository } from "./CounterCustomerChargeRepo";

/**
 * For template
 * @returns 
 */
export const CounterCustomerChargeRepoImpl = (): CounterCustomerChargeRepository => {
    const url = '/v1/counterCustomerCharge';

    const onlineSearchByCriteria = async (criteria: CounterCustomerChargeSearchCriteria): Promise<ResponseEntity> => {
        return await axiosPostData(documentAxiosInstance, `${url}/onlineSearch`, criteria).then(res => {
            return res
        }).catch(err => {
            return [];
        });
    }

    const searchByCriteria = async (criteria: CounterCustomerChargeSearchCriteria): Promise<CounterCustomerChargeEntity[]> => {
        const newUrl = '/v1/searchCounterCustomer';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, criteria).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });
    }

    const cfsAndUnStuffingDownload = async (criteria: CounterCustomerChargeSearchCriteria): Promise<ResponseEntity> => {
        const newUrl = '/v1/cfsAndUnStuffingDownload';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, criteria).then(res => {
            return res
        }).catch(err => {
            return [];
        });
    }

    const createEntity = async (newData: CounterCustomerChargeEntity): Promise<ResponseEntity> => {
        return await axiosPostData(documentAxiosInstance, `${url}`, newData);
    }

    const updateAdditional = async (updatedData: CounterCustomerChargeEntity): Promise<ResponseEntity> => {
        const newUrl = '/v1/updateAdditional';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, updatedData)/*.then((res) => {
            return res.data;
        })*/.catch(err => {
            return null;
        });
    }

    const updateEntity = async (updatedData: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/updateCounterCustomer';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, updatedData);
    }

    const deleteEntity = async (key: string): Promise<ResponseEntity> => {
        return await axiosDeleteData(documentAxiosInstance, `${url}`, key);
    }

    const searchAdditionalByid = async (ids: number[]): Promise<CounterCustomerChargeEntity[]> => {
        const result = axiosPostData(chargeAxiosInstance, `${url}/searchAdditionalById`, ids).then(res => {
            const data = res.data;
            return data
        }).catch(error => {
            return null
        })
        return result
    }

    const searchAdditionalByCriteria = async (criteria: CounterCustomerChargeSearchCriteria): Promise<CounterCustomerChargeEntity[]> => {
        const result = axiosPostData(chargeAxiosInstance, `${url}/searchAdditionalByCriteria`, criteria).then(res => {
            const data = res.data;
            return data
        }).catch(error => {
            return null
        })
        return result
    }

    const applyAll = async (ids: number[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/counterCustomerChargeApply';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, ids).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const applyAdditional = async (counterCusts: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/applyAdditionalCharge';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, counterCusts).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const confirmAndSubmit = async (criteria: CounterCustomerChargeSearchCriteria): Promise<ResponseEntity> => {
        const newUrl = '/v1/confirmAndSubmit';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, criteria).then(res => {
            return res
        }).catch(err => {
            return null;
        });
    }

    const deleteAdditional = async (ids: number[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/deleteAdditionalCharge';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, ids).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const markMT = async (ids: number[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/markMT';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, ids).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const editWaiver = async (ids: number[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/editWaiver';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, ids).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const suppleWaiver = async (updatedData: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/supplementaryWaiver';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, updatedData).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const previewDocReport = async (draftDocNos: string[]): Promise<any> => {
        const newUrl = url + "/preview";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, draftDocNos).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const searchVesselInfo = async (criteria: CounterCustomerChargeEntity): Promise<AdditionChargeVesselEntity[]> => {
        const newUrl = '/v1/searchVessel';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, criteria).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });
    }

    const reject = async (id: number[]): Promise<ResponseEntity> => {
        const newUrl = url + "/reject";
        const result = axiosPostData(documentAxiosInstance, `${newUrl}`, id).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const getDocumentHdrById = async (id: number): Promise<any> => {
        const newUrl = "/v1/documentHdr";

        return axiosGetData(documentAxiosInstance, `${newUrl}/${id}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const getCollectionDetailByHdrId = async (id: number): Promise<any> => {
        const newUrl = "/v1/getCollectionDtlByDocHdrId";

        return axiosPostData(collectionAxiosInstance, `${newUrl}`, id).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const applyPaymentMode = async (criteria: PaymentModeAdditionalInfoCriteria): Promise<any> => {
        const newUrl = "/v1/updateCollectionHdr";

        return axiosPostData(collectionAxiosInstance, `${newUrl}`, criteria).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const saveCollectionDtlForPayment = async (dtl: CollectionDetailEntity): Promise<any> => {
        const newUrl = "/v1/saveCollectionDtlForPayment";

        return axiosPostData(collectionAxiosInstance, `${newUrl}`, dtl).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const collection = async (draftDocNos: string[]): Promise<ResponseEntity> => {
        const newUrl = url + "/collection";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, draftDocNos).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const adjustment = async (updatedData: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/counterCustomerAdjustment';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, updatedData).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const checkAdjustment = async (updatedData: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/checkAdjustment';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, updatedData).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const previewDraftInvoice = async (ids: number[]): Promise<any> => {
        const newUrl = url + "/previewDraftInvoice";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, ids).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const holdUnHold = async (ids: number[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/holdUnhold';
        const result = axiosPostData(chargeAxiosInstance, `${newUrl}`, ids).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const accTerminal = async (updatedData: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/accTerminal';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, updatedData);
    }

    const isConditionCheckPaidThroughDate = async (selectedRows: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/isConditionCheckPaidThroughDate';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, selectedRows);
    }

    const stuffing = async (updatedData: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/stuffing';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, updatedData);
    }

    const importReHandling = async (criteria: ImportReHandlingCriteria): Promise<ResponseEntity> => {
        const newUrl = '/v1/importReHandling';
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, criteria);
    }

    const getCollectionHdr = async (criteria: PaymentModeAdditionalInfoCriteria): Promise<any> => {
        const newUrl = "/v1/getCollectionHdr";

        return axiosPostData(collectionAxiosInstance, `${newUrl}`, criteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const isCalculatePayment = async (headerList: CollectionHeaderEntity[]): Promise<any> => {
        const newUrl = "/v1/calculatePaymentAmount";

        return axiosPostData(collectionAxiosInstance, `${newUrl}`, headerList).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const printForAQCT = async (draftDocNos: string[]): Promise<ResponseEntity> => {
        const newUrl = url + "/collection/printForAQCT";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, draftDocNos).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const checkChargeDataForMultipleBL = async (criteria: CounterCustomerChargeSearchCriteria): Promise<any> => {

        return axiosPostData(documentAxiosInstance, `${url}/checkMultipleBL`, criteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return null;
        });
    }

    const copyChargeDataWithMultipleConsignee = async (criteria: CounterCustomerChargeSearchCriteria): Promise<ResponseEntity> => {
        return await axiosPostData(documentAxiosInstance, `${url}/copyChargeDataWithMultipleConsignee`, criteria);
    }

    const checkAgenDate = async (entity: CounterCustomerChargeEntity): Promise<boolean> => {
        const newUrl = "/v1/checkAgenDate";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, entity).then(res => {
            if (res && res.success) {
                return true;
            } else {
                return false;
            }
        }).catch(err => {
            return false;
        });
    }

    const getOldPaymentMode = async (entity: CounterCustomerChargeEntity): Promise<PaymentModeAdditionalInfoCriteria> => {
        const newUrl = "/v1/counterCustomerCharge/getOldPaymentMode";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, entity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return false;
        });
    }

    const updatePaidThroughDate = async (updatedData: Map<string, Date>): Promise<ResponseEntity> => {
        const newUrl = "/v1/updatePaidThroughDate";
        const data = Object.fromEntries(updatedData);
        return axiosPostData(chargeAxiosInstance, `${newUrl}`, data).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const checkExtensionPayment = async (entity: CounterCustomerChargeEntity[]): Promise<boolean> => {
        const newUrl = "/v1/checkExtensionPayment";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, entity).then(res => {
            if (res && res.success) {
                return res.data;
            } else {
                return false;
            }
        }).catch(err => {
            return false;
        });
    }

    const updateExtensionPayment = async (updatedData: Map<string, CounterCustomerChargeEntity>): Promise<ResponseEntity> => {
        const newUrl = "/v1/updateExtensionPayment";
        const data = Object.fromEntries(updatedData);
        return axiosPostData(chargeAxiosInstance, `${newUrl}`, data).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const getPreviousDate = async (entity: CounterCustomerChargeEntity[]): Promise<ResponseEntity> => {
        const newUrl = "/v1/getPreviousDate";
        return axiosPostData(chargeAxiosInstance, `${newUrl}`, entity).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const checkPaidThroughDate = async (entity: CounterCustomerChargeEntity[]): Promise<boolean> => {
        const newUrl = "/v1/checkPaidThroughDate";
        return axiosPostData(chargeAxiosInstance, `${newUrl}`, entity).then(res => {
            if (res && res.success) {
                return res.data;
            } else {
                return false;
            }
        }).catch(err => {
            return false;
        });
    }

    const checkBookingCntrNo = async (draftDocNos: string[]): Promise<ResponseEntity> => {
        const newUrl = url + "/checkBookingCntrNo";

        const result = await axiosPostData(documentAxiosInstance, `${newUrl}`, draftDocNos).then(res => {
            return res;
        }).catch(err => {
            return null;
        });
        return result;
    }

    const getDocHdrIds = async (draftDocNos: string[]): Promise<any> => {
        const newUrl = url + "/getDocHdrIds";

        return axiosPostData(documentAxiosInstance, `${newUrl}`, draftDocNos).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return false;
        });
    }

    const checkBookingChargeCntrWithNgen = async (ids: number[]): Promise<ResponseEntity> => {
        const newUrl = '/v1/checkBookingChargeCntr';
        const result = await axiosPostData(chargeAxiosInstance, `${newUrl}`, ids).then(res => {
            return res
        }).catch(error => {
            return null
        })
        return result
    }

    const getPaidThroughDateForFSP = async (entity: CounterCustomerChargeEntity[]): Promise<any> => {
        const newUrl = '/v1/getPaidThroughDateForFSP';
        return axiosPostData(chargeAxiosInstance, `${newUrl}`, entity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return null;
        });
    }

    return {
        onlineSearchByCriteria: onlineSearchByCriteria,
        searchByCriteria: searchByCriteria,
        createEntity: createEntity,
        updateAdditional: updateAdditional,
        updateEntity: updateEntity,
        deleteEntity: deleteEntity,
        searchAdditionalByid: searchAdditionalByid,
        applyAll: applyAll,
        applyAdditional: applyAdditional,
        confirmAndSubmit: confirmAndSubmit,
        deleteAdditional: deleteAdditional,
        markMT: markMT,
        editWaiver: editWaiver,
        suppleWaiver: suppleWaiver,
        previewDocReport: previewDocReport,
        searchVesselInfo: searchVesselInfo,
        reject: reject,
        getDocumentHdrById: getDocumentHdrById,
        getCollectionDetailByHdrId: getCollectionDetailByHdrId,
        applyPaymentMode: applyPaymentMode,
        saveCollectionDtlForPayment: saveCollectionDtlForPayment,
        collection: collection,
        adjustment: adjustment,
        checkAdjustment: checkAdjustment,
        previewDraftInvoice: previewDraftInvoice,
        holdUnHold: holdUnHold,
        accTerminal: accTerminal,
        isConditionCheckPaidThroughDate: isConditionCheckPaidThroughDate,
        stuffing: stuffing,
        importReHandling: importReHandling,
        getCollectionHdr: getCollectionHdr,
        isCalculatePayment: isCalculatePayment,
        printForAQCT: printForAQCT,
        cfsAndUnStuffingDownload: cfsAndUnStuffingDownload,
        checkChargeDataForMultipleBL: checkChargeDataForMultipleBL,
        copyChargeDataWithMultipleConsignee: copyChargeDataWithMultipleConsignee,
        checkAgenDate: checkAgenDate,
        getOldPaymentMode: getOldPaymentMode,
        updatePaidThroughDate: updatePaidThroughDate,
        checkExtensionPayment: checkExtensionPayment,
        updateExtensionPayment: updateExtensionPayment,
        getPreviousDate: getPreviousDate,
        checkPaidThroughDate: checkPaidThroughDate,
        searchAdditionalByCriteria: searchAdditionalByCriteria,
        checkBookingCntrNo: checkBookingCntrNo,
        getDocHdrIds: getDocHdrIds,
        checkBookingChargeCntrWithNgen: checkBookingChargeCntrWithNgen,
        getPaidThroughDateForFSP: getPaidThroughDateForFSP,
    }
}